<ng-container *ngIf="elementHtml else loadingTemplate">
  <div [innerHtml]="elementHtml | safeHtml"></div>
</ng-container>

<ng-template #loadingTemplate>
  Loading...
</ng-template>
